module.exports = __webpack_public_path__ + "img/web6.d42d0366.png";